import {$authHost} from './index';
import {requestBody, readIncomingDto, readIncomingError} from '../utils/adminPreorderIncomingProfiles';

// Only the existing authenticated host/interceptor supplies credentials. No
// incoming request changes tokens, persisted handles, retries or guest state.
const ROOT = 'api/admin/preorder-incoming/';
const business = operation => ['confirm', 'revise', 'recover'].includes(operation);
const uncertain = operation => !['target', 'current'].includes(operation);
const errorFor = (kind, operation) => Object.assign(new Error('Не удалось проверить операцию поставки.'),
  {kind, status: null, outcomeUnknown: uncertain(operation), recoveryRequired: uncertain(operation)});
const inputError = () => Object.assign(new Error('Не удалось проверить операцию поставки.'),
  {kind: 'input', status: null, outcomeUnknown: false, recoveryRequired: false});
const own = (value, key) => {
  if (!value || typeof value !== 'object') throw inputError();
  const descriptor = Object.getOwnPropertyDescriptor(value, key);
  if (!descriptor || !descriptor.enumerable || !Object.prototype.hasOwnProperty.call(descriptor, 'value')) throw inputError();
  return descriptor.value;
};
const expectedCopy = (operation, source, body) => {
  try {
    const keys = business(operation) ? ['actorId', 'saved'] : ['actorId'];
    if (!source || typeof source !== 'object' || Array.isArray(source) ||
      ![Object.prototype, null].includes(Object.getPrototypeOf(source)) || Reflect.ownKeys(source).length !== keys.length) throw inputError();
    const actorId = own(source, 'actorId');
    if (!Number.isSafeInteger(actorId) || actorId < 1 || actorId > 2147483647) throw inputError();
    if (operation === 'commands' && body.before !== null && body.before.ownerUserId !== actorId) throw inputError();
    if (!business(operation)) return Object.freeze({actorId, body});
    const rawSaved = own(source, 'saved'), state = own(rawSaved, 'registryState');
    let saved;
    if (state === 'prepared') {
      saved = readIncomingDto('prepare', rawSaved, {actorId,
        body: {operation: own(rawSaved, 'operation'), command: own(rawSaved, 'command')}});
    } else if (state === 'found') {
      saved = readIncomingDto('command', rawSaved, {actorId,
        body: {operationId: body.operationId, commandSha256: body.commandSha256}});
    } else throw inputError();
    if (saved.operationId !== body.operationId || saved.commandSha256 !== body.commandSha256 ||
      operation === 'revise' && saved.operation !== 'revision' ||
      operation === 'confirm' && saved.operation === 'revision') throw inputError();
    return Object.freeze({actorId, body, saved});
  } catch (_) {throw inputError();}
};
const noStore = response => {
  const headers = own(response, 'headers');
  // AxiosHeaders holds its normalized fields as DATA properties. No header
  // getter/toJSON, status coercion or raw exception method is invoked here.
  if (own(headers, 'cache-control') !== 'no-store') throw inputError();
};
const transportFailure = (cause, operation) => {
  try {
    if (!cause || typeof cause !== 'object') return errorFor('network', operation);
    const descriptor = Object.getOwnPropertyDescriptor(cause, 'response');
    if (!descriptor || Object.prototype.hasOwnProperty.call(descriptor, 'value') && descriptor.value == null)
      return errorFor('network', operation);
    if (!descriptor.enumerable || !Object.prototype.hasOwnProperty.call(descriptor, 'value')) return errorFor('contract', operation);
    const response = descriptor.value;
    noStore(response);
    return readIncomingError(own(response, 'status'), own(response, 'data'));
  } catch (_) {return errorFor('contract', operation);}
};
const send = async (operation, rawBody, rawExpected) => {
  let body, expected;
  // An async function executes this complete own-DATA snapshot synchronously,
  // before Axios's first interceptor await; caller mutations cannot rebind it.
  try {body = requestBody(operation, rawBody); expected = expectedCopy(operation, rawExpected, body);}
  catch (_) {throw inputError();}
  let response;
  try {
    response = await $authHost.post(ROOT + operation, body,
      {headers: {'Content-Type': 'application/json', 'X-YW-Incoming-Action': '1'}, withCredentials: false});
  } catch (cause) {throw transportFailure(cause, operation);}
  try {
    if (own(response, 'status') !== 200) throw inputError();
    noStore(response);
    return readIncomingDto(operation, own(response, 'data'), expected);
  } catch (_) {throw errorFor('contract', operation);}
};
export const getIncomingTarget = (body, expected) => send('target', body, expected);
export const getIncomingCurrent = (body, expected) => send('current', body, expected);
export const prepareIncomingCommand = (body, expected) => send('prepare', body, expected);
export const discoverIncomingCommands = (body, expected) => send('commands', body, expected);
export const getIncomingCommand = (body, expected) => send('command', body, expected);
export const confirmIncomingCommand = (body, expected) => send('confirm', body, expected);
export const reviseIncomingCommand = (body, expected) => send('revise', body, expected);
export const recoverIncomingCommand = (body, expected) => send('recover', body, expected);
